import React from 'react';

interface BookingNotesProps {
  notes: string;
}

export const BookingNotes: React.FC<BookingNotesProps> = ({ notes }) => {
  return (
    <div className="mx-4 mb-4 p-4 bg-amber-50 border border-amber-200 rounded-xl">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-amber-700 mb-2 flex items-center gap-2">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        Booking Notes
      </h3>
      <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
        {notes}
      </p>
    </div>
  );
};
